import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { createHybridStorage } from "./cookieStorage";

interface CandidateAuthState {
  token: string;
  firstName: string;
  email: string;
  evaluationId: string;
  parcoursId: string;
  setToken: (token: string) => void;
  setFirstName: (firstName: string) => void;
  setEmail: (email: string) => void;
  setEvaluationId: (evaluationId: string) => void;
  setParcoursId: (parcoursId: string) => void;
  clearToken: () => void;
  clear: () => void;
}

// Storage key for the auth data
const STORAGE_KEY = "candidate-auth";

// Create hybrid storage that uses cookies in production and localStorage in development
const hybridStorage = createHybridStorage<CandidateAuthState>(STORAGE_KEY, {
  days: 1, // 24 hours
  secure: true,
  sameSite: "Lax",
});

export const useCandidateAuthStore = create<CandidateAuthState>()(
  persist(
    (set) => ({
      token: "",
      firstName: "",
      email: "",
      evaluationId: "",
      parcoursId: "",
      setToken: (token) =>
        set({
          token,
        }),
      setFirstName: (firstName) =>
        set({
          firstName,
        }),
      setEmail: (email) =>
        set({
          email,
        }),
      setEvaluationId: (evaluationId) =>
        set({
          evaluationId,
        }),
      setParcoursId: (parcoursId) =>
        set({
          parcoursId,
        }),
      clearToken: () => set({ token: "", firstName: "", email: "" }),
      clear: () =>
        set({
          token: "",
          firstName: "",
          email: "",
          evaluationId: "",
          parcoursId: "",
        }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => hybridStorage),
    },
  ),
);
